import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Alert from "@material-ui/lab/Alert";
import httpClient, { setHttpClientToken } from "../services.httpClient";

const Login = ({ setIsLoggedIn, setUser }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");

  const login = async () => {
    try {
      const { data } = await httpClient.post("/users/login", {
        email: username,
        password: password,
      });

      setIsLoggedIn(true);
      setUser(data.user);
      localStorage.setItem("udistriAuth", data.user.apiKey);
      setHttpClientToken(data.user.apiKey);
    } catch (error) {
      setLoginError("invalid username or password");
    }
  };
  return (
    <div className="login">
      <div className="login-wrapper">
        <h3>Login</h3>
        <div className="login-error">
          {loginError && <Alert severity="error">{loginError}</Alert>}
        </div>

        <div className="input-wrapper">
          <label htmlFor="name">Email</label>
          <input
            type="text"
            id="name"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className="input-wrapper">
          <label htmlFor="password">password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <Button onClick={() => login()} variant="contained" color="primary">
          Log in
        </Button>
      </div>
    </div>
  );
};

export default Login;
